export enum ProductType {
	Medicine = 1,
	HospitalEquipment = 2,
	Other = 3,
}
